import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { useBookings } from "../../contexts/BookingsContext";
import { clinic } from "../../data/clinic";
import { findNextAvailable } from "../../utils/slots";
import { formatRelativeDay, formatTime } from "../../utils/format";
export function Hero() {
  const {
    isSlotTaken
  } = useBookings();
  const next = useMemo(() => findNextAvailable(30, isSlotTaken), [isSlotTaken]);
  return <section className="bg-surface" data-id="element-175" data-mp="5p7as9iue3uf">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-14 md:px-8 md:py-20 lg:grid-cols-12 lg:gap-16" data-id="element-176" data-mp="5o5mv4gq9mva">
        <div className="lg:col-span-7" data-id="element-177" data-mp="s73jva9av1q">
          <p className="text-sm font-medium text-brand" data-id="element-178" data-mp="3rxgq1cz1kr6l">{clinic.tagline}</p>
          <h1 className="mt-4 text-4xl font-semibold leading-[1.1] tracking-tight text-ink md:text-5xl lg:text-[3.5rem]" data-id="element-179" data-mp="1v453t7ql8glh">
            Soulager, rééduquer, prévenir. Au cœur d'Étréchy.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-muted md:text-lg" data-id="element-180" data-mp="1mwm3a3dwzy82">
            Un cabinet réunissant kinésithérapie, ostéopathie, orthophonie et psychomotricité, pour une
            prise en charge personnalisée et bienveillante — avec ou sans ordonnance.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-181" data-mp="1hx9j5qefh596">
            <Link to="/reservation" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-182" data-mp="1hxhtbaj61wgo">
              Prendre rendez-vous en ligne
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="20uaoxdft39e6" />
            </Link>
            <a href={clinic.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full border border-line bg-white px-7 py-3.5 text-sm font-medium text-ink transition-colors duration-150 hover:border-brand hover:text-brand" data-id="element-184" data-mp="2ok50lroe2rwu">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-185" data-mp="2yalogq3nju0t" />
              {clinic.phone}
            </a>
          </div>

          <div className="mt-12 flex flex-col gap-1 border-t border-line pt-6 sm:flex-row sm:items-center sm:gap-6" data-id="element-186" data-mp="2u5vuj6sk0pij">
            <p className="text-sm text-muted" data-id="element-187" data-mp="2paynu6iqys8t">Prochain créneau disponible</p>
            {next ? <Link to="/reservation?service=reeducation" className="group inline-flex items-center gap-2 text-base font-semibold text-ink" data-id="element-188" data-mp="2fisuascuk2ri">
                {formatRelativeDay(next.date)} à {formatTime(next.time)}
                <ArrowRightIcon className="h-4 w-4 text-brand transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-189" data-mp="26jpa1l1y1hbf" />
              </Link> : <p className="text-base font-semibold text-ink" data-id="element-190" data-mp="c1wa1kvu4llw">Appelez le cabinet</p>}
          </div>
        </div>

        <div className="lg:col-span-5" data-id="element-191" data-mp="h0h8pfvfux88">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/a91047fb-807b-4ab3-bc33-90ff72bdef78.jpg" alt="Séance de kinésithérapie de l'épaule au cabinet RD-Kiné" className="aspect-[4/5] w-full rounded-3xl object-cover" data-id="element-192" data-mp="gzfpup86l6fy" />
        </div>
      </div>
    </section>;
}